import styled from "styled-components";
import { MAX_WIDTH_PAGE } from "../../styles";

export const Wrapper = styled.div`
  padding: 16px;
  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 16px 48px 32px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 48px;
    margin-top: 0;
    max-width: ${MAX_WIDTH_PAGE};
    margin: auto;
  }
`;
